import React, { useRef } from "react";
import { Button } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ManImg from "./images/man.jpg";
import Logo from "./images/logo-light-blue.png";
import Sign from "./images/Narf_signature.png";
import "./pdf.css";
const TemplatePdf = () => {
  const contentRef = useRef();
  // const imgUrl =
  //   "https://vibeapi.tridentnets.com/storage/posp/kyc/photos/agent_photo_20240614071946.png";

  // Function to fetch the image and convert it to Base64
  // async function getBase64ImageFromUrl(imgUrl) {
  //   const response = await fetch(imgUrl);
  //   const blob = await response.blob();
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => resolve(reader.result);
  //     reader.onerror = reject;
  //     reader.readAsDataURL(blob);
  //   });
  // }

  // Usage

  // getBase64ImageFromUrl(imgUrl)
  //   .then((base64Image) => {
  //     console.log("base64Image", base64Image);

  //     // Embed the base64 image into an HTML img tag
  //     const imgElement = `<img class="mb-2" src="${base64Image}" />`;

  //     // Assuming you want to display this in your HTML
  //     document.body.innerHTML += imgElement; // or any other container instead of `body`
  //   })
  //   .catch((error) =>
  //     console.error("Error converting image to Base64:", error)
  //   );

  // const draw = () => {
  //   const canvas = document.getElementById("myCanvas");
  //   const ctx = canvas.getContext("2d");
  //   const img = document.getElementById("scream");
  //   ctx.drawImage(img, 10, 10);
  // };
  const handleDownload = async () => {
    const content = contentRef.current;

    const scale = 3;
    // Use html2canvas to capture the content as an image
    const canvas = await html2canvas(content, {
      scale: scale,
      useCORS: true,
      allowTaint: true,
    });
    const imgData = canvas.toDataURL("image/png");

    // Create a jsPDF instance
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a4",
      compress: true,
    });

    // Add the captured image to the
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

    // Save the PDF
    pdf.save("vibe_posp_certificate.pdf");
  };

  return (
    <div style={{ height: "100%" }}>
      {/* <p>Image to use:</p>
      <img
        id="scream"
        src={imgUrl}
        alt="The Scream"
        width="220"
        height="277"
        // crossOrigin="anonymous"
      />

      <p>
        <button onClick={draw}>Try it</button>
      </p>

      <p>Click Try it to draw the image on the canvas.</p>
      <canvas
        id="myCanvas"
        width="250"
        height="300"
        style={{ border: "1px solid grey" }}
      ></canvas> */}
      <div
        ref={contentRef}
        style={{
          backgroundColor: "#f5f5f5",
          marginBottom: "20px",
          width: "80%",
        }}
        id="downloadableContent"
      >
        <div className="outer-pdf">
          <div className="pdf-border-container">
            <div className="content">
              <div className="d-flex justify-content-between align-items-center">
                <img src={Logo} style={{ width: "130px" }}></img>
                <div className="avatar-pdf">
                  <img src={ManImg}></img>
                </div>
              </div>
              <div className="pdf-txt-cntnt mb-3">
                <div className="text-center pdf">
                  {/* <img src={TitleImg} style={{ width: "90%" }}></img> */}
                  <h1>
                    VIBE INSURANCE BROKING AND ADVISORY <br />
                    SERVICE PRIVATE LIMITED
                  </h1>
                  <p className="mb-2">Point Of Sale</p>
                  <p>Training Certificate</p>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-4 pdf-reg">
                  <p>Registration No. POS-840H-202405</p>
                  <p>Date: 05-01-24</p>
                </div>
              </div>
              <div className="certify-content">
                This is to certify that <b>Mr./Ms. A Branesh</b>
                [Aadharno. <b>XXXXXXXX0532</b> | PAN No: <b>XXXXXX840H</b>] has
                successfully completed the prescribed training on{" "}
                <b>05-01-24</b> specified for Point of Sales Person examination
                conducted by Vibe Insurance Broking and Advisory Service Pvt Ltd
                under the Guidelines of IRDAI (Ref No. IRDAI/DB1027/2023 dated
                04.07.2023)
              </div>
              <br />
              <br />
              <div className="pdf-txt-cntnt">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="text-center">
                    {/* <div className="sign-pdf">Yours Truly</div> */}
                    <img src={Sign} style={{ width: "100px" }}></img>
                    <div className="sign-pdf">Principal officer</div>
                    <div className="">Kameshwaran</div>
                  </div>
                  <div className="text-center">
                    <img src={Sign} style={{ width: "100px" }}></img>
                    <div className="sign-pdf">Technical Head</div>
                    <div className="">Sivasubramaniam</div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="footer-pdf">
                NO.33/54, Mount Poonamalee Road, Near Kathipara Flyover, St.
                Thomas Mount, Chennai - 600016
              </div>
            </div>
          </div>
        </div>
      </div>
      <Button type="primary" onClick={handleDownload}>
        Download as PDF
      </Button>
    </div>
  );
};

export default TemplatePdf;
